import { GetServerSideProps, NextPage } from 'next'
import Head from 'next/head'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import React, { useContext } from 'react'

import { ContactContent } from '@Components/Contact/Content'
import { DataLayer } from '@Globals/Google/DataLayer'
import { MetadataContext } from '@Globals/Metadata'
import { genericHeaders } from '@Globals/Page/Server'
import { useTranslation } from '@Globals/Translations'
import { OneColumn } from '@Layouts/OneColumn'

export const getServerSideProps: GetServerSideProps = async ({ locale = '', req, res }) => {
  genericHeaders({ req, res, surrogateKeys: ['CON'] })

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'footer', 'header', 'info', 'contact', 'sidebar', 'validation'])),
      page: {
        id: '',
        type: 'contact',
      },
    },
  }
}

const ContactPage: NextPage = () => {
  const { t } = useTranslation()
  const { storeURL } = useContext(MetadataContext)

  return (
    <>
      <Head>
        <title>{t('contact:CONTACT_PAGE_TITLE')}</title>
        <meta
          key="og:title"
          content={t('contact:CONTACT_PAGE_TITLE')}
          property="og:title"
        />
        <meta
          key="og:url"
          content={storeURL('info/contact')}
          property="og:url"
        />
        <meta
          key="og:image"
          content="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/bltaff2926b4bbffad0/63d23d37da01a5667fceef72/OG_image_Trendhim_medium.jpg"
          property="og:image"
        />
        <meta
          key="og:site_name"
          content="Trendhim"
          property="og:site_name"
        />
        <meta
          key="og:type"
          content="article"
          property="og:type"
        />
        <meta
          key="robots"
          content="INDEX,FOLLOW"
          name="robots"
        />
      </Head>
      <DataLayer input={{ contentIds: '', pageType: 'contact' }} />
      <OneColumn>
        <ContactContent />
      </OneColumn>
    </>
  )
}

export default ContactPage
